import React from 'react';

const ArrowDawnIcon: React.FC<{ rotate?: boolean }> = ({ rotate }) => (
  <svg
    width="45"
    height="45"
    viewBox="0 0 45 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      transform: `rotate(${rotate ? 0 : 180}deg)`,
      transition: '0.3s ease-in-out'
    }}
  >
    <rect x="45" y="45" width="45" height="45" rx="22.5" transform="rotate(-180 45 45)" fill="#F2F4F7" />
    <path
      d="M28.5 24.5L22.5 18.5L16.5 24.5"
      stroke="#344054"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowDawnIcon;
